export default "__VITE_ASSET__BDYF4sjb__"